import merge from 'lodash/merge';
import { StyleSheet } from 'react-native';
import { gradientViewConfig } from '../../constants';
import { fitContentWidth } from '../../utils';
export var getGradientViewConfigData = props => {
  var _a;
  var gradientConfigData = (_a = props === null || props === void 0 ? void 0 : props.config) === null || _a === void 0 ? void 0 : _a[props === null || props === void 0 ? void 0 : props.type];
  return gradientConfigData;
};
export var getGradientViewStyles = () => {
  return StyleSheet.create({
    container: Object.assign({
      position: 'relative',
      overflow: 'hidden'
    }, fitContentWidth())
  });
};
export var getGradientViewProps = (props, context) => {
  var _a;
  var theme = (props === null || props === void 0 ? void 0 : props.theme) || (context === null || context === void 0 ? void 0 : context.theme);
  var configProps = merge(gradientViewConfig === null || gradientViewConfig === void 0 ? void 0 : gradientViewConfig[theme], (_a = context === null || context === void 0 ? void 0 : context.gradientView) === null || _a === void 0 ? void 0 : _a[theme]);
  return Object.assign(Object.assign({
    theme
  }, configProps), props);
};